import { z } from 'zod';

export const productImportErrorKindSchema = z.enum([
    'VALIDATION',
    'MAPPING_MISSING',
    'IMAGE_UPLOAD_FAILED',
    'CONFLICT_DUPLICATE',
    'DATA_INCOMPLETE',
    'SELLER_SPU_ID_MISSING',
    'OTHER',
]);

export type ProductImportErrorKindSchema = z.infer<typeof productImportErrorKindSchema>;
